import { useEffect, useState } from "react";
import { formatDateDash } from "../../../../utils/helpers";
import INTOUCH_API from "../../../../services/Api";
import PersonalAccount from "../../../../store/PersonalAccount";
import useValidateForm from "../../../../hooks/useValidateForm";
import useModalActions from "../../../../hooks/useModalActions";
import { MODAL_TYPES } from "../../../../utils/emitter";
import { toJS } from "mobx";
import useCookie from "../../../../hooks/useCookie";

export default function useController(deactivateEditProfile) {
  const { openModal } = useModalActions();
  const [isSaving, setIsSaving] = useState(false);
  const [editFormData, setEditFormData] = useState({
    firstName: "",
    email: "",
    birthday: "",
    gender: "",
  });
  const [password, setPassword] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const {
    manageValidate,
    comparableText,
    onComparableTextHandle,
    isValidEmail,
    isConsistency,
    isBirthdayValid,
    getValidGenders,
    formatDate,
    checkConsistency,
    validateBirthday,
  } = useValidateForm();
  const { removeCookie } = useCookie();
  removeCookie("inviterGender")

  const onSubmitForm = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    setIsSaving(true);
    const formData = editFormData;
    formData.birthday = formatDateDash(formData.birthday);
    if (password?.length) {
      const formDataPassUpdate = { password };
      await sendReqUpdatePass(formDataPassUpdate);
    }
    delete formData.password;
    delete formData.repeat_pass;
    await sendReqUpdateUser(formData);
    PersonalAccount.getPersonalAccountData()
      .then(() => {
        deactivateEditProfile();
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const showDeleteProfilePopup = (e) => {
    e.preventDefault();
    openModal(MODAL_TYPES.REMOVE_PROFILE);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    manageValidate(name, value);
    setEditFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setIsEdit(true);
  };
  const onPassHandleChange = (event) => {
    setPassword(event.target.value);
    setIsEdit(true);
  };
  const onBirthdayHandle = (value) => {
    validateBirthday(formatDate(value));
    setEditFormData({
      ...editFormData,
      birthday: formatDate(value),
    });
    setIsEdit(true);
  };
  const sendReqUpdateUser = async (formData) => {
    await INTOUCH_API.requestManager(
      "user_data_update",
      formData,
      (response) => {},
      (error) => {}
    ).finally(() => {});
  };

  const sendReqUpdatePass = async (formData) => {
    await INTOUCH_API.requestManager(
      "password_update",
      formData,
      (response) => {},
      (error) => {}
    ).finally(() => {});
  };

  const setDefaultEditRegisterFormData = () => {
    setEditFormData((prevState) => ({
      ...prevState,
      firstName: PersonalAccount.user.firstName,
      birthday: PersonalAccount.user.birthday,
      email: PersonalAccount.user.email,
      gender: PersonalAccount.user.gender,
    }));
  };

  const validBirthdayIfExist = () => {
    if (editFormData?.birthday?.length) {
      return isBirthdayValid.validFormat && isBirthdayValid.validAge;
    }
    return true;
  };

  useEffect(() => {
    return () => {
      setIsSaving(null);
    };
  }, []);

  useEffect(() => {
    checkConsistency(password, comparableText);
  }, [password, comparableText]);

  useEffect(() => {
    setDefaultEditRegisterFormData();
  }, [PersonalAccount.user]);

  return {
    showDeleteProfilePopup,
    onSubmitForm,
    isSaving,
    handleChange,
    comparableText,
    getValidGenders,
    onComparableTextHandle,
    onPassHandleChange,
    onBirthdayHandle,
    password,
    editFormData,
    isValidEmail,
    isConsistency,
    isBirthdayValid,
    isEdit,
    validBirthdayIfExist,
  };
}
